import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpenseAccountCamera from './ExpenseAccountCamera';
import i18next from 'i18next';
import styles from '../../styles/expenseAccount.module.css';

export default function OptionExpenseAccountDialog(props) {
    const { onClose, selectedValue, open, detail, document } = props;
    const [openCamera, setOpenCamera] = React.useState(false);
    const [openLibrary, setOpenLibrary] = React.useState(false);

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleCloseLibrary = () => {
        setOpenLibrary(false);
    };

    const handleCloseCamera = () => {
        setOpenCamera(false);
    }

    const handleListItemClick = (value) => {
        onClose(value);
    };

    const handleOpenCamera = () => {
        handleClose();
        setOpenCamera(true);
    }

    const handleOpenLibrary = () => {
        setOpenLibrary(true);
    }

    const isCameraDisabled = () => {
        if (navigator.userAgent.match('CriOS')) {
            return true;
        }
        return false;
    }

    return (
        <React.Fragment>
            <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} className={styles.option}>
                <DialogTitle id="simple-dialog-title">{i18next.t('expenseAccount:option.title')}</DialogTitle>
                <List>
                    <ListItem button onClick={handleOpenCamera} disabled={isCameraDisabled()}>
                        <ListItemText primary={i18next.t('expenseAccount:option.camera')} />
                    </ListItem>
                    <ListItem button onClick={handleOpenLibrary}>
                        <ListItemText primary={i18next.t('expenseAccount:option.library')} />
                    </ListItem>
                    <ListItem button onClick={handleClose}>
                        <ListItemText primary={i18next.t('expenseAccount:form.cancel')} />
                    </ListItem>
                </List>
            </Dialog>
            <ExpenseAccountCamera open={openCamera} onClose={handleCloseCamera} />
        </React.Fragment>
    );
}